import apiClient from "@/shared/api/apiClient";

export const updateUserMeContact = async (params) => {
  const { data } = await apiClient.patch("/users/me/contact/", { ...params });
  return data;
};

export const getRoleList = async (params) => {
  try {
    const { data } = await apiClient.get("/roles/list/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("[user] getRoleList", e);
  }
};

let rolesCache = null;
let rolesPromise = null;

export function loadRolesOnce() {
  if (rolesCache) return Promise.resolve(rolesCache);
  if (!rolesPromise) {
    rolesPromise = getRoleList({})
      .then((res) => {
        rolesCache =
          res?.success && Array.isArray(res?.payload?.items)
            ? res.payload.items
            : [];
        return rolesCache;
      })
      .catch(() => {
        rolesCache = [];
        return rolesCache;
      });
  }
  return rolesPromise;
}
